import posthog, { type PostHogConfig } from "posthog-js"
import { type PostHog, PostHogProvider } from "posthog-js/react"
import { memo, useEffect } from "react"
import { useLocation } from "react-router"

const options: Partial<PostHogConfig> = {
  api_host: import.meta.env.VITE_POSTHOG_HOST,
  capture_pageview: false,
  debug: import.meta.env.DEV,
  ui_host: import.meta.env.VITE_POSTHOG_UI_HOST,
  rageclick: true,
}

// eslint-disable-next-line react-refresh/only-export-components
export const loadPostHog = () => {
  if (import.meta.env.VITE_POSTHOG_API_KEY) {
    posthog.init(import.meta.env.VITE_POSTHOG_API_KEY, options)
  } else {
    posthog.init("fake-token", {
      autocapture: false,
      loaded: function (posthog: PostHog) {
        posthog.opt_out_capturing()
      },
    })
  }
}

function AnalyticsProvider({ children }: { children: React.ReactNode }) {
  const location = useLocation()

  useEffect(() => {
    posthog.capture("$pageview")
  }, [location.pathname])

  return <PostHogProvider client={posthog}>{children}</PostHogProvider>
}

const MemoizedAnalyticsProvider = memo(AnalyticsProvider)
MemoizedAnalyticsProvider.displayName = "AnalyticsProvider"

export default MemoizedAnalyticsProvider

// eslint-disable-next-line react-refresh/only-export-components
export const sendSearchEvent = (query: string) => {
  posthog.capture("search", {
    query,
  })
}
